import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import LeftPanel from '../components/LeftPanel';
import PrimaryButton from '../components/PrimaryButton';

function CIGComplete() {
    const navigate = useNavigate();
    useEffect(() => {
        const timer = setTimeout(() => navigate('/grantlanding'), 5000);
        return () => clearTimeout(timer);
    }, [navigate]);
    return (
        <Box component="main">
            <Grid container spacing={4} sx={{ mt: 2 }}>
                <Grid item xs={12} md={4} lg={3}>
                    <LeftPanel items={["Application received.", "We'll email updates.", "Returning to grants shortly."]}>
                        <PrimaryButton sx={{ bgcolor: '#fff', color: '#000', textTransform: 'none' }} onClick={() => navigate('/grantlanding')}>Back to Grants</PrimaryButton>
                    </LeftPanel>
                </Grid>
                <Grid item xs={12} md={8} lg={6}>
                    <Paper elevation={1} sx={{ p: { xs: 3, md: 4 } }}>
                        <Typography variant="h5" sx={{ fontWeight: 700 }}>Campus Improvement Grant</Typography>
                        <Typography sx={{ mt: 2 }}>Application submitted! Redirecting to grants...</Typography>
                    </Paper>
                </Grid>
            </Grid>
        </Box>
    );
}
export default CIGComplete;
